import type { AccountingInvoice } from './accounting-invoice.type.ts';
export interface AccountingInvoiceExtension extends AccountingInvoice {}
export class AccountingInvoiceExtension {
  /**************************
   **  Computed Properties **
   **************************/
  get isCreated() {
    return this.state === 'CREATED';
  }

  get isApproved() {
    return this.state === 'APPROVED';
  }

  get isFunded() {
    return this.state === 'FUNDED';
  }

  get isDisbursed() {
    return this.state === 'DISBURSED';
  }

  get isDisbursing() {
    return this.state === 'DISBURSING';
  }

  get isAutomated() {
    return this.invoiceType === 'AUTOMATED';
  }

  get canUpdateLineItems() {
    // TODO: this should be false if theres also an unlocked adhoc invoice for the same period
    // protecting against that case in the backend for now
    return this.isCreated && this.isAutomated;
  }

  get canApprove() {
    return this.isCreated;
  }

  get canUnlock() {
    return this.isApproved;
  }

  get canVoid() {
    return this.isCreated || this.isApproved;
  }

  get canFund() {
    return this.isApproved;
  }

  get canEditLineItems() {
    return this.isCreated;
  }

  get canAddLineItems() {
    return this.isCreated;
  }
}

const Registration = {
  kind: 'object',
  name: 'accounting-invoice',
  features: AccountingInvoiceExtension,
};
export default Registration;
